import { createAction } from '@ngrx/store';

export const userPreferencesActions = {
  toggleSideNav: createAction('[User Preferences] Toggle Side Nav'),
};
